export const UI_ACTION_TYPES = {
    SEARCH_OPEN: 'SEARCH_OPEN',
    SEARCH_CLOSE: 'SEARCH_CLOSE',
    AUTH_OPEN: 'AUTH_OPEN',
    AUTH_CLOSE: 'AUTH_CLOSE',
    MENU_OPEN: 'MENU_OPEN',
    MENU_CLOSE: 'MENU_CLOSE',
    SET_FORM_CHANGED: 'SET_FORM_CHANGED',
    RESET_FORM_CHANGED: 'RESET_FORM_CHANGED',
    SET_COUNTRY: 'SET_COUNTRY',
    SET_REGION: 'SET_REGION',
};
